import apiCall from "../../utils/apiCall";
import { apiUrls } from "../../constants/apiUrls";
import type {
    AiRouteSuggestionDto,
    ApprovePlannedRouteRequest,
    ApprovePlannedRouteResponse,
    PlannedRoutesResponse,
    TriggerAiRouteGenerationRequest,
} from "../../types/api/planRoute/routePlanning.types";

export const routePlanningService = {
    generate: (body: TriggerAiRouteGenerationRequest) =>
        apiCall.post<{ routeDate: string; message: string }>(
            apiUrls.planRoute.routePlanning.generate,
            body
        ),
    regenerate: (body: TriggerAiRouteGenerationRequest) =>
        apiCall.post<{ routeDate: string; message: string }>(
            apiUrls.planRoute.routePlanning.regenerate,
            body
        ),

    approve: (body: ApprovePlannedRouteRequest) =>
        apiCall.post<ApprovePlannedRouteResponse | void>(apiUrls.planRoute.routePlanning.approve, body),

    getSuggestions: (routeDate: string) =>
        apiCall.get<AiRouteSuggestionDto[]>(
            apiUrls.planRoute.routePlanning.suggestions,
            { params: { routeDate } }
        ),

    /**
     * Утверждённые / превью маршруты для карты.
     * `transportIds` — ID ТС с карты (как `List<string> transportIds` на бэке); одна строка `a,b,c` или см. биндинг ASP.NET.
     */
    getPlannedRoutes: (
        routeDate: string,
        algorithm?: string | null,
        options?: { transportIds?: string[] }
    ) =>
        apiCall.get<PlannedRoutesResponse>(apiUrls.planRoute.routePlanning.plannedRoutes, {
            params: {
                routeDate,
                ...(algorithm != null && algorithm !== "" ? { algorithm } : {}),
                ...(options?.transportIds?.length
                    ? { transportIds: options.transportIds.join(",") }
                    : {}),
            },
        }),

    excelExport: (routeDate: string) =>
        apiCall.get(
            apiUrls.planRoute.routePlanning.excelExport(routeDate),
            {
                responseType: "blob",
            }
            )
};
